import React, { Component } from 'react';

class SelectRecruiters extends Component{
    constructor(props){
        super(props);
        this.state = {
            recruiterId: this.props.recruiterId
        };
        
        this.handleChange = (event) => {
            const recruiterId = event.target.value;
            this.props.onSelectRecruiterChange(recruiterId);
            this.setState({recruiterId: recruiterId})
        };
    }

    render(){
        const { recruiters, title, classname, label, disabledAll } = this.props;
        return(
            <div className={classname}>
                <label className="control-label" htmlFor="selectRecruiter">{label}</label>
                <select className="form-control" value={this.state.recruiterId} onChange={this.handleChange} title={title}>
                    <option value="0" disabled={disabledAll}>Todos</option>
                    {recruiters.map((recruiter) => {
                        const nameRecruiter = `${recruiter.nombre1} ${recruiter.apellidoPaterno}`;
                        return <option key={recruiter.id} value={recruiter.id}>{nameRecruiter}</option>
                    })}
                </select>
            </div>
        )
    }
}

export default SelectRecruiters;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/SelectRecruiters.jsx